import React from 'react';
import TextField, {
  INPUT_PATTERN_EMAIL,
  VALIDATION_PATTERN_EMAIL,
} from 'styleguide/form/Text';

import { Field } from '../types';

export interface Props extends Field {
  disabled?: boolean;
  onChange: (value: fhir.ContactPoint | undefined) => void;
  onValidate: (isValid: boolean) => void;
  required?: boolean;
  value: fhir.ContactPoint | undefined;
}

const Email: React.FC<Props> = ({
  value: data,
  disabled,
  onChange,
  onValidate,
  required,
  name = 'email',
}) => {
  const handleChange = (value: string) => {
    onChange({
      ...data,
      value,
    });
  };

  return (
    <TextField
      disabled={disabled}
      inputPattern={INPUT_PATTERN_EMAIL}
      label="Email"
      name={name}
      onChange={handleChange}
      onValidate={onValidate}
      required={required}
      validationPattern={VALIDATION_PATTERN_EMAIL}
      value={data?.value}
      endIcon="email"
      isEndIconDisabled
    />
  );
};

export default React.memo(Email);
